import {memo} from 'react';

import type {SVGProps} from 'react';

export const BuyerIcon = memo(function BuyerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M14.6665 16.368C17.6878 16.368 20.1371 13.9187 20.1371 10.8973C20.1371 7.87594 17.6878 5.42664 14.6665 5.42664C11.6451 5.42664 9.1958 7.87594 9.1958 10.8973C9.1958 13.9187 11.6451 16.368 14.6665 16.368Z"
          fill="var(--icon-fill-purple)"
        />
        <path
          d="M23.9993 23.2414C23.9993 30.9647 5.33398 30.9647 5.33398 23.2414C5.33398 21.8194 6.48665 20.6667 7.90865 20.6667H21.4253C22.8473 20.6667 24 21.8194 23.9993 23.2414Z"
          fill="var(--icon-fill-purple)"
        />
        <path
          d="M8.63616 3.43931C9.57683 2.74398 10.7408 2.33331 12.0002 2.33331C15.1295 2.33331 17.6668 4.87065 17.6668 7.99998C17.6668 11.1293 15.1295 13.6666 12.0002 13.6666C8.87083 13.6666 6.3335 11.1293 6.3335 7.99998"
          stroke="var(--icon-stroke-purple)"
          strokeWidth={2}
          strokeMiterlimit={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4855 26.9933C7.4955 27.1313 2.3335 25.134 2.3335 21C2.3335 19.5273 3.5275 18.3333 5.00016 18.3333H15.5462"
          stroke="var(--icon-stroke-purple)"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7368 17.9567C21.7001 17.3727 22.8221 17.0433 24.0001 17.0667C27.4668 17.0667 30.3335 20 30.2668 23.4"
          stroke="var(--icon-stroke-purple)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.5333 27.8C27.4 29 25.7333 29.6667 23.9333 29.6667C20.4667 29.6667 17.6 26.7333 17.6667 23.3333C17.6667 22.778 17.742 22.238 17.8827 21.7227"
          stroke="var(--icon-stroke-purple)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 21.1334V25.5334"
          stroke="var(--icon-stroke-purple)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1998 23.3333H21.7998"
          stroke="var(--icon-stroke-purple)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
